import { makeExactRegexp } from './regularExpression'

export const EMAIL_SEARCH_REGEXP = /[^\s@]+@([a-zA-Z-]+\.)+[a-zA-Z-]+/
export const EMAIL_EXACT_REGEXP = makeExactRegexp(EMAIL_SEARCH_REGEXP)

export function isValidEmail(email: string) {
  return EMAIL_EXACT_REGEXP.test(email)
}
